import React from 'react'
import PropTypes from 'prop-types'

const Checkbox = ({
  checked = false,
  id,
  name,
  onChange,
  disabled,
  type = 'checkbox',
}) => (
  <input
    checked={checked}
    disabled={disabled}
    id={id}
    name={name}
    onChange={onChange}
    type={type}
  />
)

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox.js